import { useEffect, useState } from 'react';

/**
 * Says you are offline, and that it does not matter.
 *
 * Deliberately informative rather than alarming: this app is built to be used
 * with no signal, and a red warning would teach a trainee that logging at 3am
 * in a side room is a degraded state. It is the normal state.
 */
export function OfflineBanner() {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const goOnline = (): void => setOnline(true);
    const goOffline = (): void => setOnline(false);

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="status"
      className="border-b border-line bg-surface-raised px-4 py-2 text-center text-xs text-muted"
    >
      Offline — logging works as normal, and entries back up when you have signal.
    </div>
  );
}
